(function () {
  'use strict';

  var SECTION_SELECTOR = '.oddit-section-recipe-carousel';
  var ACTIVE_INDICATOR_CLASS = 'oddit-section-recipe-carousel__indicator--active';
  var GAP = 16;

  function initSection(section) {
    if (!section || section.dataset.odditInit === 'true') return;
    section.dataset.odditInit = 'true';

    var track = section.querySelector('.oddit-section-recipe-carousel__track');
    var indicatorsContainer = section.querySelector('.oddit-section-recipe-carousel__indicators');
    var cards = Array.prototype.slice.call(
      section.querySelectorAll('.oddit-section-recipe-carousel__card')
    );

    if (!track || cards.length === 0) return;

    var indicators = [];

    function getCardsPerPage() {
      if (cards.length === 0) return 1;
      var trackWidth = track.clientWidth;
      var cardWidth = cards[0].getBoundingClientRect().width;
      if (cardWidth <= 0) return 1;
      var perPage = Math.round((trackWidth + GAP) / (cardWidth + GAP));
      return Math.max(1, Math.min(perPage, cards.length));
    }

    function getNumPages() {
      var perPage = getCardsPerPage();
      return Math.max(1, Math.ceil(cards.length / perPage));
    }

    function getPageStep() {
      var numPages = getNumPages();
      if (numPages <= 1) return 0;
      var maxScroll = track.scrollWidth - track.clientWidth;
      if (maxScroll <= 0) return 0;
      return maxScroll / (numPages - 1);
    }

    function getPageFromScroll() {
      var step = getPageStep();
      if (step <= 0) return 0;
      var numPages = getNumPages();
      return Math.min(numPages - 1, Math.max(0, Math.round(track.scrollLeft / step)));
    }

    function setActiveIndicator(index) {
      if (indicators.length === 0) return;
      var clamped = Math.max(0, Math.min(index, indicators.length - 1));
      indicators.forEach(function (dot, i) {
        if (i === clamped) {
          dot.classList.add(ACTIVE_INDICATOR_CLASS);
          dot.setAttribute('aria-selected', 'true');
        } else {
          dot.classList.remove(ACTIVE_INDICATOR_CLASS);
          dot.setAttribute('aria-selected', 'false');
        }
      });
    }

    function buildIndicators() {
      if (!indicatorsContainer) return;
      var numPages = getNumPages();

      indicatorsContainer.innerHTML = '';
      indicators = [];

      if (numPages <= 1) {
        indicatorsContainer.style.display = 'none';
        return;
      }
      indicatorsContainer.style.display = '';

      for (var i = 0; i < numPages; i++) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'oddit-section-recipe-carousel__indicator';
        dot.setAttribute('aria-label', 'Go to page ' + (i + 1));
        dot.setAttribute('aria-selected', 'false');
        var span = document.createElement('span');
        span.setAttribute('aria-hidden', 'true');
        span.innerHTML = '&zwnj;';
        dot.appendChild(span);

        (function (pageIndex) {
          dot.addEventListener('click', function () {
            var step = getPageStep();
            track.scrollTo({
              left: step * pageIndex,
              behavior: 'smooth'
            });
            setActiveIndicator(pageIndex);
          });
        })(i);

        indicatorsContainer.appendChild(dot);
        indicators.push(dot);
      }
    }

    var scrollRaf = null;
    function onScroll() {
      if (scrollRaf) cancelAnimationFrame(scrollRaf);
      scrollRaf = requestAnimationFrame(function () {
        setActiveIndicator(getPageFromScroll());
        scrollRaf = null;
      });
    }

    var resizeRaf = null;
    function onResize() {
      if (resizeRaf) cancelAnimationFrame(resizeRaf);
      resizeRaf = requestAnimationFrame(function () {
        buildIndicators();
        setActiveIndicator(getPageFromScroll());
        resizeRaf = null;
      });
    }

    track.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onResize);

    // Mouse drag-to-scroll (touch already works natively via overflow-x).
    var isDown = false;
    var startX = 0;
    var startScroll = 0;
    var dragged = false;
    var pendingX = null;
    var moveRaf = null;

    function applyPending() {
      moveRaf = null;
      if (!isDown || pendingX === null) return;
      track.scrollLeft = startScroll - (pendingX - startX);
    }

    track.addEventListener('mousedown', function (e) {
      if (e.button !== 0) return;
      if (e.target.closest('a')) return;
      isDown = true;
      dragged = false;
      startX = e.pageX;
      startScroll = track.scrollLeft;
      pendingX = e.pageX;
      track.style.cursor = 'grabbing';
      track.style.scrollSnapType = 'none';
      track.style.userSelect = 'none';
      section.classList.add('is-dragging');
      e.preventDefault();
    });

    window.addEventListener('mousemove', function (e) {
      if (!isDown) return;
      pendingX = e.pageX;
      if (Math.abs(pendingX - startX) > 8) dragged = true;
      if (moveRaf === null) {
        moveRaf = requestAnimationFrame(applyPending);
      }
    });

    var restoreSnapTimer = null;
    function restoreSnapAfter(ms) {
      if (restoreSnapTimer) clearTimeout(restoreSnapTimer);
      restoreSnapTimer = setTimeout(function () {
        track.style.scrollSnapType = '';
        restoreSnapTimer = null;
      }, ms);
    }

    function endDrag() {
      if (!isDown) return;
      isDown = false;
      if (moveRaf !== null) {
        cancelAnimationFrame(moveRaf);
        moveRaf = null;
      }
      track.style.cursor = 'grab';
      track.style.userSelect = '';
      section.classList.remove('is-dragging');

      if (dragged) {
        // Smooth-snap to nearest page boundary instead of letting CSS snap
        // jerk the carousel into position.
        var step = getPageStep();
        var numPages = getNumPages();
        if (step > 0 && numPages > 1) {
          var pageIndex = Math.min(
            numPages - 1,
            Math.max(0, Math.round(track.scrollLeft / step))
          );
          track.scrollTo({ left: step * pageIndex, behavior: 'smooth' });
          setActiveIndicator(pageIndex);
        }
        // Keep CSS snap off until the smooth scroll has had time to settle,
        // then restore so wheel/touch interactions still snap normally.
        restoreSnapAfter(700);
      } else {
        track.style.scrollSnapType = '';
      }
    }

    window.addEventListener('mouseup', endDrag);
    window.addEventListener('mouseleave', endDrag);
    window.addEventListener('blur', endDrag);

    track.addEventListener('click', function (e) {
      if (dragged) {
        if (!e.target.closest('a')) {
          e.preventDefault();
          e.stopPropagation();
        }
        dragged = false;
      }
    }, true);

    track.style.cursor = 'grab';

    buildIndicators();
    setActiveIndicator(getPageFromScroll());
  }

  function init() {
    var sections = document.querySelectorAll(SECTION_SELECTOR);
    Array.prototype.forEach.call(sections, initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector(SECTION_SELECTOR);
    if (section) initSection(section);
  });
})();